import type { PropsWithChildren } from 'react';

import { Button } from '@nesso/ui/primitives/button';
import {
    Card,
    CardContent,
    CardDescription,
    CardFooter,
    CardHeader,
    CardTitle,
} from '@nesso/ui/primitives/card';

import { DictateRecapBeacon } from './dictate-recap/dictate-recap-beacon';

type Props = {
    hasRecordedToday: boolean;
    onStartDictation?: () => void;
    disabled?: boolean;
    disabledReason?: string;
    startDisabled?: boolean;
    showBeacon?: boolean;
};

export function DictateRecap({
    hasRecordedToday,
    onStartDictation,
    disabled,
    disabledReason,
    startDisabled,
    showBeacon = false,
    children,
}: PropsWithChildren<Props>) {
    return (
        <Card className="w-full xs:w-96 py-6 sm:py-8">
            <CardHeader className="sm:px-8">
                <CardTitle>Dictate a recap</CardTitle>
                {hasRecordedToday && (
                    <CardDescription>🎉 Ready for your next recap!</CardDescription>
                )}
                {disabled && disabledReason && <CardDescription>{disabledReason}</CardDescription>}
            </CardHeader>
            {/* display:contents keeps the Card's own flex gaps while still letting one disabled
                fieldset switch off the search input, the add-client link and the button together */}
            <fieldset disabled={disabled} className="contents">
                <CardContent className="sm:px-8">{children}</CardContent>
                <CardFooter className="sm:px-8">
                    {/* the beacon anchors to this wrapper rather than the Button itself, where
                        buttonVariants' disabled:opacity-50 would fade it with the fieldset */}
                    <div className="relative w-full">
                        <Button
                            className="w-full"
                            onClick={onStartDictation}
                            disabled={startDisabled}
                        >
                            Start Dictation
                        </Button>
                        {showBeacon && <DictateRecapBeacon />}
                    </div>
                </CardFooter>
            </fieldset>
        </Card>
    );
}
